export enum ProductType {
    BASE = 1,
    TALL = 2,
    UPPER = 3,
    COMPONENT = 5,
}
